module.exports = __webpack_public_path__ + "static/media/icon-agendaMedica.7ebe4c3f.svg";